import React, { useEffect, useState } from "react"
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import DMSHeader from "../DMSHeader/DMSHeader";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import ExpectedTrackForm from "./ExpectedTrackForm";

const ExpectedTrackHeader = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const [currentTab, setCurrentTab] = useState('create');
    const [isEditMode, setIsEditMode] = useState(false);
    // let edit = state?.edit;
    // let data = state?.data;
    const editRoute = state?.editRoute;
    const routeData = state?.routeData;

    useEffect(() => {
        GridStack.init();

    // Set edit mode if edit state is present
    if (editRoute && routeData) {
      setIsEditMode(true);
      setCurrentTab('create');
    }
  }, [editRoute, routeData]);

    // Handle tab change from ExpectedTrackForm
    const handleTabChange = (tabName) => {
        setCurrentTab(tabName);
    };

    // Handle edit mode change from ExpectedTrackForm
    const handleEditModeChange = (editStatus) => {
        setIsEditMode(editStatus);

        if (!editStatus) {
            setCurrentTab('list');
        }
    };

    // Determine header title based on current tab and edit mode
    const getHeaderTitle = () => {
        if (isEditMode && currentTab === 'create') {
            return t("Edit Route");
        }

        switch (currentTab) {
            case 'create':
                return t("Create Route");
            case 'assign':
                return t("Assign Route");
            case 'list':
                return t("Route List");
            default:
                return t("Create Route");
        }
    };

    const layoutData = [
        {
            x: 0,
            y: 0,
            width: 12,
            height: 1,
            id: 0,
            component: (
                <DMSHeader
                    title={getHeaderTitle()}
                    // showIconsForback={edit || isEditMode}
                />
            ),
            haveOverflowVisible: true,
        },
        {
            x: 0,
            y: 1,
            width: 12,
            height: 12,
            id: 1,
            component: (
                <ExpectedTrackForm
                    onTabChange={handleTabChange}
                    onEditModeChange={handleEditModeChange}
                />
            ),
        },
    ];

    return (
        <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
            <GridItem layoutData={layoutData} />
        </div>
    );
}

export default ExpectedTrackHeader;